import "./css/App.css";
import Home from "./pages/Home";
import Board from "./pages/TicTacToe";
import NavBar from "./components/NavBar";

import Anagrams from "./pages/Anagrams";
import AnagramsLobby from "./pages/AnagramsLobby";
import AnagramsMultiplayer from "./pages/AnagramsMultiplayer";

import ConnectFourLobby from "./pages/ConnectFourLobby";
import ConnectFour from "./pages/ConnectFour";

// import Battleship from "./pages/Battleship";
import BattleshipLobby from "./pages/BattleshipLobby";

// import DotsAndBoxes from "./pages/DotsAndBoxes";
import DotsAndBoxesLobby from "./pages/DotsAndBoxesLobby";


import { Routes, Route } from "react-router-dom";
import { useEffect } from 'react'



function App() {

    useEffect(() => {
        document.title = "SAMAGRAMS";
    }, []);
    return (
        
        <div>

            <NavBar />
            <main className="main-file">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Anagrams" element={<Anagrams />} />
                    <Route path="/AnagramsMultiplayer" element={<AnagramsMultiplayer />} />
                    <Route path="/AnagramsLobby" element={<AnagramsLobby />} /> 
                    
                    <Route path="/ConnectFourLobby" element={<ConnectFourLobby />} />
                    <Route path="/ConnectFour" element={<ConnectFour />} />
                    
                    <Route path="/BattleshipLobby" element={<BattleshipLobby />} />
                    <Route path="/Battleship" element={<BattleshipLobby />} />
                    
                    <Route path="/DotsAndBoxesLobby" element={<DotsAndBoxesLobby />} />
                    <Route path="/DotsAndBoxes" element={<DotsAndBoxesLobby />} />
                </Routes>
            </main>
        </div>
    );
}

export default App
